export default __webpack_public_path__ + "static/media/5front.9a455ecf.png";